module.exports = __webpack_public_path__ + "static/slack-6eb96af27bfc736240ad5bdccea08955.png";